import { graphql } from "react-relay";

import { OrgInvite } from "@components/org-invite";
import { AdminSelect } from "@components/admin-select";

export const adminPanelBillingGroupsMembersFragments = {
  viewer: graphql`
    fragment AdminPanelBillingGroupsMembers_viewer on Viewer {
      ...OrgInvite_viewer
    }
  `,
  org: graphql`
    fragment AdminPanelBillingGroupsMembers_org on Org
    @argumentDefinitions(
      sortType: { type: "SortType!" }
      sortDirection: { type: "SortDirection!" }
      searchQuery: { type: "String" }
      pageToken: { type: "String" }
      fetchNext: { type: "Boolean" }
      limit: { type: "Int" }
      teamId: { type: "String" }
      billingGroupId: { type: "String" }
      activityFilter: { type: "ActivityFilter" }
    ) {
      ...OrgInvite_org
      ...AdminSelect_org
        @arguments(
          sortType: $sortType
          sortDirection: $sortDirection
          searchQuery: $searchQuery
          pageToken: $pageToken
          fetchNext: $fetchNext
          limit: $limit
          teamId: $teamId
          billingGroupId: $billingGroupId
          activityFilter: $activityFilter
        )
      id
      orgPersonListPaginatedErrorable(
        sortType: $sortType
        sortDirection: $sortDirection
        searchQuery: $searchQuery
        pageToken: $pageToken
        fetchNext: $fetchNext
        limit: $limit
        teamId: $teamId
        billingGroupId: $billingGroupId
        activityFilter: $activityFilter
      ) {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on OrgPersonListPaginated {
          inputQuery
          nextPersonId
          previousPersonId
          searchPersons {
            person {
              primaryCalendarId
              userId
              personId
              signUpMillis
              isYou
              primaryBillingGroupIdErrorable {
                __typename
                ... on PrimaryBillingGroupId {
                  primaryBillingGroupId
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
              }
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
            status
          }
        }
      }
      suggestedInvites(first: 1000000) {
        edges {
          node {
            id
            targetCalendarId
            targetProfile {
              givenName
              familyName
              externalImageUrl
            }
            resolution
            numberOfSharedMeetings
            numberOfOrganizedMeetings
            inviteReason
            totalScore
          }
        }
      }

      teamsForOrg {
        __typename
        ... on TeamList {
          list {
            teamId
            teamName
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }

      billingGroups {
        ... on BillingGroupList {
          list {
            id
            name
            createdAtMillis
            invitePolicy
            type
            dsyncConfigured {
              __typename
              ... on DsyncConfigured {
                isDsyncConfigured
              }
              ... on GraphEntityError {
                statusCode
                message
              }
            }
            personListPaginatedErrorable {
              __typename
              ... on OrgPersonListPaginatedErrorable {
                __typename
                ... on GraphEntityError {
                  message
                }
                ... on OrgPersonListPaginated {
                  count
                }
              }
            }
            manualMembers {
              __typename
              ... on BillingGroupManualMemberList {
                list {
                  externalUserId
                  calendarId
                  userId
                  personId
                  orgPerson {
                    __typename
                    ... on OrgPerson {
                      userId
                      personId
                      primaryCalendarId
                      isYou
                      signUpMillis
                      profile {
                        givenName
                        familyName
                      }
                    }
                    ... on GraphEntityError {
                      message
                      statusCode
                    }
                  }
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
            adminOrgPersons {
              __typename
              ... on OrgPersonList {
                list {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
            subscription {
              __typename
              ... on SubscriptionDetails {
                subscription {
                  id
                  productType
                  seatCount
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
    }
  `,
};

export const adminPanelBillingGroupsMembersQuery = graphql`
  query AdminPanelBillingGroupsMembersQuery(
    $orgRelayId: ID!
    $sortType: SortType!
    $sortDirection: SortDirection!
    $searchQuery: String
    $pageToken: String
    $fetchNext: Boolean
    $limit: Int
    $teamId: String
    $billingGroupId: String
    $activityFilter: ActivityFilter
  ) {
    viewer {
      ...AdminPanelBillingGroupsMembers_viewer
    }
    org: node(id: $orgRelayId) {
      ... on Org {
        id
        ...AdminPanelBillingGroupsMembers_org
          @arguments(
            sortType: $sortType
            sortDirection: $sortDirection
            searchQuery: $searchQuery
            pageToken: $pageToken
            fetchNext: $fetchNext
            limit: $limit
            teamId: $teamId
            billingGroupId: $billingGroupId
            activityFilter: $activityFilter
          )
      }
    }
  }
`;
